import React from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

const PendingReservationNoticeContainer = styled.div`
  margin-top: 1.6rem;
  padding: 1.6rem 1.4rem;
  border-radius: 0.4rem;
  border: solid 1px ${({ theme }) => theme.color.yaorange200};
  background-color: ${({ theme }) => theme.color.yaorange50};
  word-break: keep-all;
  color: ${({ theme }) => theme.color.gray900};
  ${Typography('body2.multiline').regular};
`

const PendingReservationNoticeTitle = styled.h4`
  font-weight: bold;
  margin-bottom: 0.8rem;
`

const PendingReservationNoticeTextWrapper = styled.div`
  display: grid;
  gap: 0.4rem;
`

const PendingReservationNotice = ({ className }: { className?: string }) => {
  return (
    <PendingReservationNoticeContainer className={className}>
      <PendingReservationNoticeTitle>
        {'해당 예약은 ‘확정 대기’ 상태예요.'}
      </PendingReservationNoticeTitle>
      <PendingReservationNoticeTextWrapper>
        <p>
          1일 이내로 예약 확정 여부를 알려드릴게요. 이벤트/프로모션 상품 또는 성수기 기간에는 조금
          더 지연될 수 있어요.
        </p>
        <p>
          예약 확정 전까지 무료로 취소할 수 있고, 예약 확정 불가로 결정되면 자동 취소 후 전액 환불
          처리돼요.
        </p>
      </PendingReservationNoticeTextWrapper>
    </PendingReservationNoticeContainer>
  )
}

export default PendingReservationNotice
